import { z } from 'zod';

export const fieldLayoutShape = {
  fieldLayout: z.enum(['vertical', 'horizontal']).default('vertical'),
} as const;

export type FieldLayout = z.infer<typeof fieldLayoutShape.fieldLayout>;
